import React, { PropsWithChildren } from 'react';
import MuiHidden, { HiddenProps } from '@material-ui/core/Hidden';
import { getDefaultBreakpoint } from '../../core/util/device/screen';

const Hidden = ({ children, only }: PropsWithChildren<HiddenProps>) => (
  <MuiHidden initialWidth={getDefaultBreakpoint()} only={only}>
    {children}
  </MuiHidden>
);

export default Hidden;
